var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _g2, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_2749)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332 133H180C163.431 133 150 146.431 150 163V329C150 345.569 163.431 359 180 359H332C348.569 359 362 345.569 362 329V163C362 146.431 348.569 133 332 133Z",
    fill: "#E8E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.78 359.23L249.21 209.45L361.95 359.23H135.78Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.21 209.45L180.09 359.23",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.21 209.45L226.43 359.23",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.21 209.45L318.32 359.23",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.21 209.45L271.98 359.23",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.59 323.94H333.96",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.29 333.81L158.62 342.85H175.3L172.29 333.81Z",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.65 333.81L337.32 342.85H320.64L323.65 333.81Z",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.48 335.19L202.62 344H214.37L216.71 335.19H206.48Z",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.15 335.19L296.01 344H284.26L281.92 335.19H292.15Z",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M254.38 339.65C254.38 342.51 252.06 344.82 249.21 344.82C246.36 344.82 244.04 342.5 244.04 339.65C244.04 336.8 246.36 334.48 249.21 334.48C252.06 334.48 254.38 336.8 254.38 339.65Z",
    stroke: "#E8E7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.32 214.04H241.09V197.13C241.09 192.65 244.72 189.02 249.2 189.02C253.68 189.02 257.31 192.65 257.31 197.13V214.04H257.32Z",
    fill: "#132148"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M117.5 338.69C117.5 338.69 319.82 346.26 270.82 313.28C221.82 280.3 190.21 274.66 246.74 272.04C303.27 269.42 341.25 262.59 275.29 250",
    stroke: "#6840FD",
    strokeOpacity: 0.4,
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.22 223.12H267.28V244.06H288.22V223.12Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.56 238.83C266.56 238.83 266.07 236.23 268.66 236.42C271.25 236.61 270.51 243.27 273.34 242.28C276.17 241.29 278.02 240.18 280.49 241.66C282.96 243.14 284.59 240.45 286.41 239.39C288.23 238.33 289.49 238.41 289.61 242.37C289.73 246.34 293.17 254.72 286.03 254.6C278.89 254.48 266.73 258.09 266.52 249.87C266.31 241.65 266.56 238.82 266.56 238.82V238.83Z",
    fill: "#9747FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M271.45 214.17H284.07C286.37 214.17 288.23 216.04 288.23 218.33V226.33H267.29V218.33C267.29 216.03 269.16 214.17 271.45 214.17Z",
    fill: "#F1F2F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M281.6 197.97H273.9V216.27H281.6V197.97Z",
    fill: "#F1F2F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M281.6 133H273.9V197.97H281.6V133Z",
    fill: "#553222"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.44 157.63L312.03 176.07C295.21 177.35 292.9 167.04 292.9 167.04L289.46 168.66C293.39 177.3 287.19 179.99 287.19 179.99L284.55 175.32C284.72 181.07 280.55 182.61 280.55 182.61L277.44 174.84C277.27 178.66 273.43 180.2 273.43 180.2C273.43 180.2 271.53 173.48 270.31 167.52C268.94 160.84 274.4 155.65 274.4 155.65L270.51 157.84C268.34 171.37 261.84 170.39 261.84 170.39C261.84 170.39 260.99 162.84 264.86 153.41C267.55 146.87 281.4 144.59 281.4 144.59C281.4 144.59 307.81 142.58 322.44 157.62V157.63Z",
    fill: "#EDD6CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M277.44 174.83C277.44 174.83 272.57 160.12 286.34 153.66",
    stroke: "#132148",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M284.55 175.31C284.55 175.31 278.16 162.79 290.71 158.98",
    stroke: "#132148",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M283.84 148.9C283.84 148.9 278.38 151.65 274.13 155.87",
    stroke: "#132148",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M345.94 220.25C352.932 220.25 358.6 206.532 358.6 189.61C358.6 172.688 352.932 158.97 345.94 158.97C338.948 158.97 333.28 172.688 333.28 189.61C333.28 206.532 338.948 220.25 345.94 220.25Z",
    fill: "#6840FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_2749",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 333,
    y: 158,
    width: 26,
    height: 63
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M345.94 220.25C352.932 220.25 358.6 206.532 358.6 189.61C358.6 172.688 352.932 158.97 345.94 158.97C338.948 158.97 333.28 172.688 333.28 189.61C333.28 206.532 338.948 220.25 345.94 220.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_2749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.03 176.07L354.43 220.25L361.95 181.24L322.44 157.63L312.03 176.07Z",
    fill: "#CFB7AD"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.03 176.07L339.41 204.59L357.01 178.29L322.44 157.63L312.03 176.07Z",
    fill: "#EDD6CC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.913 276.56C129.599 283.001 128.02 290.369 124.63 297.346C121.293 304.31 115.979 311.46 110.407 316.691C102.726 314.857 94.7653 311.455 88.4272 306.952C82.0212 302.408 77.1704 296.724 75.4846 290.283C74.2361 285.513 74.855 281.837 76.5772 279.083C78.2286 276.333 81.025 274.607 84.1723 273.783C87.2799 273.028 90.545 273.368 93.6097 274.754C96.603 276.088 99.3102 278.359 101.198 281.508C101.166 277.874 102.399 274.513 104.423 271.867C106.379 269.238 109.045 267.288 112.313 266.432C115.582 265.577 118.811 265.725 121.598 267.314C124.385 268.902 126.668 271.804 127.916 276.574L127.913 276.56Z",
    fill: "#AFA6FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.324 245.751C144.073 250.421 140.429 254.503 135.782 257.687C131.174 260.881 125.251 263.483 119.855 264.78C115.668 260.863 111.868 255.855 109.487 250.735C107.078 245.566 106.061 240.236 107.312 235.566C108.239 232.108 109.95 230.011 112.027 228.892C114.067 227.753 116.442 227.667 118.724 228.278C120.956 228.918 122.894 230.307 124.329 232.283C125.739 234.2 126.631 236.606 126.69 239.271C127.976 236.967 129.962 235.29 132.19 234.347C134.369 233.392 136.752 233.119 139.122 233.754C141.491 234.389 143.476 235.643 144.663 237.648C145.851 239.652 146.248 242.303 145.322 245.761L145.324 245.751Z",
    fill: "#AFA6FF"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.46 321.242C153.714 328.714 149.155 335.884 142.834 341.93C136.576 347.983 128.154 353.457 120.213 356.801C112.817 351.847 105.738 345.126 100.808 337.878C95.8205 330.56 92.9248 322.646 93.6705 315.175C94.2228 309.642 96.3189 305.999 99.2197 303.763C102.044 301.503 105.676 300.776 109.325 301.141C112.906 301.561 116.223 303.203 118.918 305.871C121.558 308.455 123.527 311.919 124.287 315.989C125.679 312.134 128.301 309.065 131.478 307.062C134.577 305.05 138.159 304.034 141.949 304.413C145.738 304.791 149.093 306.215 151.415 308.988C153.737 311.762 155.011 315.725 154.458 321.258L154.46 321.242Z",
    fill: "#9747FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.713 159.934C242.285 163.773 241.904 168.458 240.365 173.055C238.859 177.639 236.138 182.504 233.101 186.205C228.179 185.717 222.955 184.284 218.65 182.033C214.299 179.764 210.821 176.658 209.249 172.82C208.085 169.977 208.171 167.654 209.017 165.807C209.827 163.965 211.416 162.667 213.305 161.894C215.175 161.166 217.231 161.102 219.249 161.701C221.217 162.273 223.085 163.45 224.514 165.237C224.199 162.993 224.691 160.813 225.733 159.008C226.735 157.219 228.233 155.79 230.194 154.986C232.156 154.183 234.175 154.003 236.036 154.751C237.897 155.498 239.552 157.1 240.716 159.942L240.713 159.934Z",
    fill: "#AFA6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_2749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 227,
    fill: "white",
    transform: "translate(58 133)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg4);
export default __webpack_public_path__ + "static/media/about_img4.2a38b78f69f453747820091bfb74e86d.svg";
export { ForwardRef as ReactComponent };